/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export var REFRESH_OPTIONS;
(function (REFRESH_OPTIONS) {
    REFRESH_OPTIONS["MARKETING_DD"] = "marketing_dd";
    REFRESH_OPTIONS["MARKETING_UE"] = "marketing_ue";
    REFRESH_OPTIONS["MARKETING_GH"] = "marketing_gh";
    REFRESH_OPTIONS["OPERATIONS_DD"] = "operations_dd";
    REFRESH_OPTIONS["OPERATIONS_UE"] = "operations_ue";
    REFRESH_OPTIONS["OPERATIONS_GH"] = "operations_gh";
    REFRESH_OPTIONS["SALES_DD"] = "sales_dd";
    REFRESH_OPTIONS["SALES_UE"] = "sales_ue";
    REFRESH_OPTIONS["SALES_GH"] = "sales_gh";
    REFRESH_OPTIONS["STORE_DETAILS_DD"] = "store_details_dd";
    REFRESH_OPTIONS["STORE_DETAILS_UE"] = "store_details_ue";
    REFRESH_OPTIONS["STORE_DETAILS_GH"] = "store_details_gh";
    REFRESH_OPTIONS["INGEST_MENU_HOURS_DD"] = "ingest_menu_hours_dd";
    REFRESH_OPTIONS["INGEST_MENU_HOURS_UE"] = "ingest_menu_hours_ue";
    REFRESH_OPTIONS["INGEST_MENU_HOURS_GH"] = "ingest_menu_hours_gh";
    REFRESH_OPTIONS["INGEST_STORE_MENU_DD"] = "ingest_store_menu_dd";
    REFRESH_OPTIONS["INGEST_STORE_MENU_UE"] = "ingest_store_menu_ue";
    REFRESH_OPTIONS["INGEST_STORE_MENU_GH"] = "ingest_store_menu_gh";
    REFRESH_OPTIONS["ORDERS_UE"] = "orders_ue";
    REFRESH_OPTIONS["ORDERS_DD"] = "orders_dd";
    REFRESH_OPTIONS["ORDERS_GH"] = "orders_gh";
    REFRESH_OPTIONS["REVIEWS_DD"] = "reviews_dd";
    REFRESH_OPTIONS["REVIEWS_UE"] = "reviews_ue";
    REFRESH_OPTIONS["REVIEWS_GH"] = "reviews_gh";
    REFRESH_OPTIONS["CONVERSION_DD"] = "conversion_dd";
    REFRESH_OPTIONS["CONVERSION_UE"] = "conversion_ue";
    REFRESH_OPTIONS["CONVERSION_GH"] = "conversion_gh";
    REFRESH_OPTIONS["INGEST_FINANCE_DEPOSITS_DD"] = "ingest_finance_deposits_dd";
    REFRESH_OPTIONS["INGEST_FINANCE_DEPOSITS_UE"] = "ingest_finance_deposits_ue";
    REFRESH_OPTIONS["INGEST_FINANCE_DEPOSITS_GH"] = "ingest_finance_deposits_gh";
    REFRESH_OPTIONS["STORE_INACTIVE_HISTORY_DD"] = "store_inactive_history_dd";
    REFRESH_OPTIONS["STORE_INACTIVE_HISTORY_UE"] = "store_inactive_history_ue";
    REFRESH_OPTIONS["STORE_INACTIVE_HISTORY_GH"] = "store_inactive_history_gh";
    REFRESH_OPTIONS["REPORTS_DD"] = "reports_dd";
})(REFRESH_OPTIONS || (REFRESH_OPTIONS = {}));
